module.exports = __webpack_public_path__ + "img/66600.e12218cf.jpg";